module.exports = __webpack_public_path__ + "linkedin.png?59adb09bf95e3f5bd839fedec09c73d9";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/linkedin.png
// module id = 295
// module chunks = 0